import { render, staticRenderFns } from "./SpecialPrice.vue?vue&type=template&id=22256917&scoped=true"
import script from "./SpecialPrice.vue?vue&type=script&lang=js"
export * from "./SpecialPrice.vue?vue&type=script&lang=js"
import style0 from "./SpecialPrice.vue?vue&type=style&index=0&id=22256917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22256917",
  null
  
)

export default component.exports